import { Box } from 'portal-commons';
import { useState, useEffect } from 'react';
import NumericLabel from 'react-pretty-numbers';
import { Link } from 'react-router-dom';
import { faDiagramVenn, faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  CSP_CAMPAIGNS_PATH,
  DCA_CAMPAIGNS_DEFAULT_ENTRY,
} from '../../../constants/paths';
import { globalGetService } from '../../../utils/globalApiServices';

const option = {
  justification: 'C',
  locales: 'en-AU',
  percentage: false,
  wholenumber: null,
  commafy: true,
  shortFormat: true,
  shortFormatMinValue: 10000,
  shortFormatPrecision: 2,
  title: true,
  cssClass: ['red'],
};

export default function DashboardCount(props) {
  const { type, count } = props;
  const [pendingCount, setPendingCount] = useState('');

  useEffect(() => {
    if (type == 'primaryDca') {
      globalGetService(`dca/campaigns/primaryDca`, {
        sharingStatus: 'PENDING',
        status: 'ACTIVE',
      }).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setPendingCount(response.data.totalRecords);
        }
      });
    }
  }, [type]);
  return (
    <div
      className={`campaigns-count-block ${
        type == 'primaryDca' ? 'primaryDca' : ''
      }`}
      data-testid="dashboardCount"
    >
      {type == 'primaryDca' ? (
        <>
          <h3 className="paragraph">
            <Box flexDirection="row">
              <Box margin={{ right: 's' }}>
                <FontAwesomeIcon
                  icon={faBullhorn}
                  style={{ color: '00AC9D', fontSize: '28px' }}
                />
              </Box>
              <span>
                Campaigns
                <br /> Pending Review
              </span>
            </Box>
          </h3>
          <p className="text-center count">
            {pendingCount || pendingCount === 0 ? (
              <NumericLabel params={option}>{pendingCount}</NumericLabel>
            ) : (
              '--'
            )}
          </p>
          <p className="text-center link">
            <Link
              data-testid="dashboardCountReviewButton"
              to={{
                pathname: CSP_CAMPAIGNS_PATH,
                search: `?sharingStatus=PENDING&status=ACTIVE&provisional=false`,
              }}
              className="primary-btn"
            >
              Review
            </Link>
          </p>
        </>
      ) : (
        <>
          <h3 className="paragraph">
            <Box flexDirection="row">
              <Box margin={{ right: 's' }}>
                <FontAwesomeIcon
                  icon={faDiagramVenn}
                  style={{ color: 'FE772D', fontSize: '28px' }}
                />
              </Box>
              <span>
                Campaigns by
                <br /> Primary DCAs
              </span>
            </Box>
          </h3>
          <p className="text-center count">
            {count || count === 0 ? (
              <NumericLabel params={option}>{count}</NumericLabel>
            ) : (
              '--'
            )}
          </p>
          <p className="text-center link">
            <Link
              data-testid="dashboardCountViewAllButton"
              to={DCA_CAMPAIGNS_DEFAULT_ENTRY}
              className="primary-btn"
            >
              View All
            </Link>
          </p>
        </>
      )}
    </div>
  );
}
